import React from 'react';
import { useField } from 'formik';
import { clsx } from 'clsx';

export default function FormField({ label, options, labelAction = null, ...props }) {
  const [field, meta] = useField(props);
  
  if (props.type === 'select') {
    return (
      <div>
        <div className="flex items-center gap-1 mb-1">
          <label className="block text-sm font-medium text-gray-700">
            {label}
          </label>
          {labelAction && labelAction}
        </div>
        <select
          {...field}
          {...props}
          className={clsx(
            'mt-1 block w-full rounded-md shadow-sm',
            'border-gray-300 focus:border-indigo-500 focus:ring-indigo-500',
            'py-2 pl-3 pr-10 text-base',
            { 'border-red-300': meta.touched && meta.error }
          )}
        >
          {options.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        {meta.touched && meta.error ? (
          <div className="mt-1 text-sm text-red-600">{meta.error}</div>
        ) : null}
      </div>
    );
  }

  const Component = props.type === 'textarea' ? 'textarea' : 'input';
  
  return (
    <div>
      <div className="flex items-center gap-1 mb-1">
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
        {labelAction && labelAction}
      </div>
      <Component
        {...field}
        {...props}
        className={clsx(
          'mt-1 block w-full rounded-md shadow-sm',
          'border-gray-300 focus:border-indigo-500 focus:ring-indigo-500',
          { 'border-red-300': meta.touched && meta.error }
        )}
      />
      {meta.touched && meta.error ? (
        <div className="mt-1 text-sm text-red-600">{meta.error}</div>
      ) : null}
    </div>
  );
}